import { useRef, useState, useLayoutEffect } from 'react';
import { useContentEnginePrinters } from '@pm2/content-engine';
import { imageComponentJsxPrinters } from '@pm2/image-component';
import { textComponentJsxPrinters } from '@pm2/text-component';
import { textComponentTokens } from '@pm2/text-component/selectors';
import { breakpoints } from '@ui/css';
import { colors } from '@ui/kit/design-tokens';
import { SplitComponentGraphic } from '@ui/kit/icons';
import { printAST } from '@utils/ast';
import { useMatchBreakpoint, useElementSize } from '@utils/react';
import { imageCaptionSize, textSize, image, graphic, text, wrapper } from './_split-component.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function SplitComponent(props) {
  const {
    interceptor
  } = useContentEnginePrinters();
  const isMobile = useMatchBreakpoint(breakpoints.mobile, {
    immediate: true
  });
  const ref = useRef(null);
  const imageRef = useRef(null);
  const textRef = useRef(null);
  const [imageCaptionNode, setImageCaptionNode] = useState(null);
  useElementSize(imageCaptionNode, {
    applyTo: ref,
    axis: "vertical",
    varName: imageCaptionSize.propName
  });
  useElementSize(textRef, {
    applyTo: ref,
    axis: "vertical",
    varName: textSize.propName
  }, [isMobile]);
  useLayoutEffect(() => {
    if (imageCaptionNode?.isConnected) {
      return;
    }
    setImageCaptionNode(imageRef.current?.querySelector("[data-is-caption]") ?? null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  const content = (() => {
    const imageContent = /*#__PURE__*/jsxs("div", {
      ref: imageRef,
      className: image,
      "data-stretch": props.node.options.allowCrop,
      children: [printAST(props.node.image, imageComponentJsxPrinters, interceptor), props.node.options.withGraphic && /*#__PURE__*/jsx("div", {
        className: graphic,
        children: /*#__PURE__*/jsx(SplitComponentGraphic, {
          preserveAspectRatio: "none",
          foregroundColor: colors.primary(),
          backgroundColor: textComponentTokens.boxes.layout3.surface.border()
        })
      })]
    });
    const textNode = isMobile && props.node.options.layout === "image-text" ? {
      ...props.node.text,
      slots: {
        contentBetweenCaptionAndContent: imageContent
      }
    } : props.node.text;
    const textContent = /*#__PURE__*/jsx("div", {
      ref: textRef,
      className: text,
      children: printAST(textNode, textComponentJsxPrinters, interceptor)
    });
    switch (props.node.options.layout) {
      case "image-text":
        // NB: On mobile the image will be embedded directly into the text
        // content
        return isMobile ? textContent : /*#__PURE__*/jsxs(Fragment, {
          children: [imageContent, textContent]
        });
      case "text-image":
        return /*#__PURE__*/jsxs(Fragment, {
          children: [textContent, imageContent]
        });
    }
  })();
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: wrapper,
    "data-split": props.node.options.layout,
    "data-box": props.node.text.options.layout || "none",
    "data-stretch": props.node.options.allowCrop,
    children: content
  });
}

export { SplitComponent };
//# sourceMappingURL=_split-component.js.map
